import { IconClockHour2 } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { TimeNotesCaptureBlock as RenderTimeNotesCaptureBlock } from '../../templateRenderer/CaptureBlocks/TimeNotesCaptureBlock'
import { TimeNotesDisplayBlock as RenderTimeNotesDisplayBlock } from '../../templateRenderer/DisplayBlocks/TimeNotesDisplayBlock'
import {
  TimeNotesCaptureBlock,
  TimeNotesDisplayBlock,
} from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  SelectField,
  SwitchField,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<TimeNotesCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'timeNotes' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Time & notes',
    icon: IconClockHour2,
    helpText: 'Add notes against a date/time range',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'pickerType',
      label: 'Date picker type',
      field: SelectField,
      options: [
        { value: 'time', label: 'Time', default: true },
        { value: 'date', label: 'Date' },
        { value: 'dateTime', label: 'Date & Time' },
        { value: 'week', label: 'Week' },
        { value: 'month', label: 'Month' },
        { value: 'quarter', label: 'Quarter' },
        { value: 'year', label: 'Year' },
      ],
      required: true,
    },
    {
      name: 'captureRange',
      label: 'Capture range',
      helpText: 'Whether to capture both a start and end date/time',
      field: SwitchField,
      default: true,
    },
  ]

  public override mapFormValueToBlock(
    block: TimeNotesCaptureBlock,
    value: TimeNotesCaptureBlock['value']
  ): TimeNotesCaptureBlock {
    return { ...block, value }
  }

  public override renderBlock(
    block: TimeNotesCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderTimeNotesCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(
    block: TimeNotesDisplayBlock
  ): React.ReactNode {
    return <RenderTimeNotesDisplayBlock block={block} />
  }
}

export const TimeNotesCaptureBlockConfig = new Config()
